export default {
  title: 'Gemiste bestellingen',
  card_title: 'E-mails over gemiste bestellingen',
  intro:
    'Als niemand een bestelling binnen {{minutes}} minuten accepteert, wordt deze automatisch afgewezen. Iedereen op deze lijst krijgt dan een e-mail met de bestelling, zodat iemand contact kan opnemen.',
  default: {
    owner: 'Restauranteigenaar',
    partner: 'Partner',
    owner_missing: 'De restauranteigenaar ({{email}}) ontvangt deze e-mails niet.',
    partner_missing: 'Het standaardadres van de partner ({{email}}) ontvangt deze e-mails niet.',
  },
  empty: 'Niemand zou iets horen over gemiste bestellingen. Voeg minstens één e-mailadres toe om op te slaan.',
  save_error: 'De e-mailadressen konden niet worden opgeslagen. Controleer je verbinding en probeer het opnieuw.',
  load_error: 'De e-mailadressen konden niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
  unavailable: 'E-mails over gemiste bestellingen zijn niet beschikbaar voor dit restaurant.',
  buttons: {
    save: 'Opslaan',
    retry: 'Opnieuw proberen',
  },
  toasts: {
    saved: 'E-mails over gemiste bestellingen opgeslagen',
  },
};
